<template>
  <div class="city-agent">
    <div class="banner">
      <div class="content">
        <div class="banner-title">
          <img src="../assets/imgs/city-agent/title.png">
        </div>
        <div class="sub-title">全国招募优秀代理商 | 携手开发亿万级签证市场</div>
        <div class="now-apply" @click="scorllToBottom">立即申请</div>
      </div>
    </div>
    <div class="why-ssq">
      <div class="title-box">
        <img src="../assets/imgs/city-agent/title_left.png" class="title-left-top">
        <div class="title">为什么选择上上签</div>
        <img src="../assets/imgs/city-agent/title_right.png" class="title-right-bottom">
      </div>
      <div class="reason">
        <div>上上签是由阳光假日团队自主研发、面向旅游同业的智能签证办理 SaaS 平台，致力于实现办签流程电子化、智能化，支持同业客户在线上传</div>
        <div>资料、办理签证。同步支持电脑端和微信小程序，大幅提升办签效率，降低难度。现已签约3632家同业，办理超30万本签证。</div>
      </div>
      <ul class="detail-reason">
        <li class="reason-item">
          <div class="img">
            <img src="../assets/imgs/city-agent/icon-intelligent.png">
          </div>
          <div class="reason-title">智能化SaaS平台</div>
          <ul class="reason-desc">
            <li>手机电子化办签证</li>
            <li>办理效率即刻提升80%</li>
          </ul>
        </li>
        <li class="reason-item">
          <div class="img">
            <img src="../assets/imgs/city-agent/icon-income.png">
          </div>
          <div class="reason-title">持续可观收益</div>
          <ul class="reason-desc">
            <li>每年与上上签</li>
            <li>共享有诱惑力的提成</li>
          </ul>
        </li>
        <li class="reason-item">
          <div class="img">
            <img src="../assets/imgs/city-agent/icon-channel.png">
          </div>
          <div class="reason-title">丰富渠道优势</div>
          <ul class="reason-desc">
            <li>近400家优质</li>
            <li>签证供应商资源</li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="you-got">
      <div class="content">
        <div class="title-box">
          <img src="../assets/imgs/city-agent/title_left.png" class="title-left-top">
          <div class="title">成为城市合伙人，您将获得什么？</div>
          <img src="../assets/imgs/city-agent/title_right.png" class="title-right-bottom">
        </div>
        <div class="content-box">
          <div class="left-content">
            <ul class="gots">
              <li>
                <div class="index-box">
                  <img src="../assets/imgs/city-agent/01.png">
                </div>
                <div class="desc-box">
                  <div class="desc-title">顶尖产品</div>
                  <ul class="desc-items">
                    <li>领先的智能化电子签证平台</li>
                    <li>强大的700+签证供应链能力</li>
                  </ul>
                </div>
              </li>
              <li>
                <div class="index-box">
                  <img src="../assets/imgs/city-agent/02.png">
                </div>
                <div class="desc-box">
                  <div class="desc-title">品牌赋能</div>
                  <ul class="desc-items">
                    <li>互联网签证领先品牌赋能</li>
                    <li>快速提升合伙人地方影响力</li>
                  </ul>
                </div>
              </li>
              <li>
                <div class="index-box">
                  <img src="../assets/imgs/city-agent/03.png">
                </div>
                <div class="desc-box">
                  <div class="desc-title">市场推广</div>
                  <ul class="desc-items">
                    <li>提供宣传物料，共享展会资源</li>
                    <li>开放媒体资源，打造企业案例</li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
          <div class="right-content">
            <ul class="gots">
              <li>
                <div class="index-box">
                  <img src="../assets/imgs/city-agent/04.png">
                </div>
                <div class="desc-box">
                  <div class="desc-title">销售支持</div>
                  <ul class="desc-items">
                    <li>平台开放万级商户资源，企业轻松获客</li>
                    <li>平台负责所有售后流程，企业专注销售</li>
                  </ul>
                </div>
              </li>
              <li>
                <div class="index-box">
                  <img src="../assets/imgs/city-agent/05.png">
                </div>
                <div class="desc-box">
                  <div class="desc-title">业务培训</div>
                  <ul class="desc-items">
                    <li>获得市场、销售、运营、管理等体系化专业培训</li>
                    <li>从0到1实现业务飞跃</li>
                  </ul>
                </div>
              </li>
              <li>
                <div class="index-box">
                  <img src="../assets/imgs/city-agent/06.png">
                </div>
                <div class="desc-box">
                  <div class="desc-title">收获成就</div>
                  <ul class="desc-items">
                    <li>与上上签一路同行</li>
                    <li>相伴成长携手开启创富机会</li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="left-cover"></div>
        <div class="right-cover"></div>
      </div>
    </div>
    <div class="we-expect">
      <div class="title-box">
        <img src="../assets/imgs/city-agent/title_left.png" class="title-left-top">
        <div class="title">我们期待这样的您</div>
        <img src="../assets/imgs/city-agent/title_right.png" class="title-right-bottom">
      </div>
      <ul class="features">
        <li class="featrue">
          <div class="img-box">
            <div class="img">
              <img src="../assets/imgs/city-agent/king-of-contacts.png">
            </div>
          </div>
          <div class="content-box">
            <div class="content-title">旅游圈人脉王</div>
            <ul class="content-desc">
              <li>3年以上旅游行业经验</li>
              <li>在当地有丰富资源</li>
            </ul>
          </div>
        </li>
        <li class="featrue">
          <div class="img-box">
            <div class="img">
              <img src="../assets/imgs/city-agent/old-driver.png">
            </div>
          </div>
          <div class="content-box">
            <div class="content-title">市场扩展老司机</div>
            <ul class="content-desc">
              <li>较熟悉互联网行业</li>
              <li>优秀的市场拓展能力</li>
              <li>和客户服务意识</li>
            </ul>
          </div>
        </li>
        <li class="featrue">
          <div class="img-box">
            <div class="img">
              <img src="../assets/imgs/city-agent/entrepreneur.png">
            </div>
          </div>
          <div class="content-box">
            <div class="content-title">创业践行者</div>
            <ul class="content-desc">
              <li>高度认可上上签平台</li>
              <li>商业模式及企业价值观</li>
              <li>具备创业精神</li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
    <div class="how-become-agent">
      <div class="title-box">
        <img src="../assets/imgs/city-agent/title_left.png" class="title-left-top">
        <div class="title">怎样成为上上签城市合伙人？</div>
        <img src="../assets/imgs/city-agent/title_right.png" class="title-right-bottom">
      </div>
      <ul class="steps">
        <li class="step fill-info">
          <div class="step-img">
            <img src="../assets/imgs/city-agent/step_01.png">
          </div>
          <div class="step-desc">填写资料</div>
          <div class="step-arrow">
            <img src="../assets/imgs/city-agent/arrow-down.png">
          </div>
        </li>
        <li class="step interview">
          <div class="step-img">
            <img src="../assets/imgs/city-agent/step_02.png">
          </div>
          <div class="step-desc">
            <div class="top">电话沟通</div>
            <div class="bottom">/面试</div>
          </div>
          <div class="step-arrow">
            <img src="../assets/imgs/city-agent/arrow-up.png">
          </div>
        </li>
        <li class="step sign-protocol">
          <div class="step-img">
            <img src="../assets/imgs/city-agent/step_03.png">
          </div>
          <div class="step-desc">签订协议</div>
          <div class="step-arrow">
            <img src="../assets/imgs/city-agent/arrow-down.png">
          </div>
        </li>
        <li class="step business-training">
          <div class="step-img">
            <img src="../assets/imgs/city-agent/step_04.png">
          </div>
          <div class="step-desc">业务培训</div>
          <div class="step-arrow">
            <img src="../assets/imgs/city-agent/arrow-up.png">
          </div>
        </li>
        <li class="step officially-settled">
          <div class="step-img">
            <img src="../assets/imgs/city-agent/step_05.png">
          </div>
          <div class="step-desc">正式入驻</div>
        </li>
      </ul>
    </div>
    <div class="be-agent">
      <div class="application-form">
        <div class="form-head">
          <div class="title-box">
            <img src="../assets/imgs/city-agent/title_left.png" class="title-left-top">
            <div class="title"><img src="../assets/imgs/city-agent/application-add.png"> 申请成为上上签城市合伙人</div>
            <img src="../assets/imgs/city-agent/title_right.png" class="title-right-bottom">
          </div>
          <div class="form-attention">请仔细填写以下信息，我们将在收到信息后尽快审核</div>
        </div>
        <form name="cityAgentForm" id="city-agent-from" novalidate>
          <div class="form-field">
            <div class="form-label">
              <span class="required">*</span>加盟城市
            </div>
            <div class="form-content">
              <el-select class="province-select" v-model="agent.province_code" placeholder="省份" @change="agent.city_code=''">
                <el-option :label="v" :value="k" v-for="(v,k) in pcds[86]" :key="k"></el-option>
              </el-select>

              <el-select class="city-select" v-model="agent.city_code" placeholder="选择市">
                <el-option :label="v" :value="k" v-for="(v,k) in pcds[agent.province_code]" :key="k"></el-option>
              </el-select>
            </div>
          </div>
          <div class="form-field">
            <div class="form-label">
              <span class="required">*</span>姓名
            </div>
            <div class="form-content">
              <el-input class="text-input" type="text" v-model.trim="agent.name" :maxlength="10" placeholder="请填写您的姓名" ></el-input>
            </div>
          </div>
          <div class="form-field">
            <div class="form-label">
              <span class="required">*</span>联系电话
            </div>
            <div class="form-content">
              <el-input class="text-input" type="text" v-model.trim="agent.phone_number" :maxlength="11" placeholder="请填写您的联系电话" ></el-input>
            </div>
          </div>
          <div class="form-field email-field">
            <div class="form-label">
              <span class="required">*</span>邮箱
            </div>
            <div class="form-content email-content">
              <el-input class="text-input" type="text" v-model.trim="agent.email" :maxlength="30"
                placeholder="请填写您的收件邮箱" @input="setValidStatus" :class="{'error-field': emailInvalid}"></el-input>
              <span class="error-text" v-show="emailInvalid">请填写正确的邮箱地址</span>
            </div>
          </div>
          <div class="form-field desc-field">
            <div class="form-label">
              优势说明
            </div>
            <div class="form-content">
              <el-input class="textarea-input" type="textarea" :rows="4" placeholder="请填写您在加盟当地的资源和优势，600字以内"
                :maxlength="600" v-model="agent.advantage"></el-input>
            </div>
          </div>
          <div class="btn-box">
            <el-button class="submit-btn" type="primary" @click="addAgent" :disabled="!allFieldValid">提交申请</el-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import pcdService from '../services/pcd-service';
import utils from '../libs/utils';
import Http from '../libs/http';

export default {
  name: 'city-agent',
  data() {
    return {
      emailInvalid: false,
      agent: {
        province_code: '',
        city_code: '',
        name: '',
        phone_number: '',
        email: '',
        advantage: '',
      },
      pcds: {},
    };
  },
  computed: {
    allFieldValid() {
      return this.agent.province_code && this.agent.city_code && this.agent.name && this.agent.phone_number && this.agent.email;
    },
  },
  methods: {

    setValidStatus() {
      this.emailInvalid = false;
    },

    scorllToBottom() {
      scrollTo(0, document.documentElement.scrollHeight - 1070);
    },

    // 邮件验证
    emailValidate(email) {
      const MAIL_REG = /^[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;
      return MAIL_REG.test(email);
    },

    clearAllField() {
      this.agent = {
        province_code: '',
        city_code: '',
        name: '',
        phone_number: '',
        email: '',
        advantage: '',
      };
    },

    addAgent() {
      if (this.emailValidate(this.agent.email)) {
        this.loadding = true;
        Http.post('/sys/city_partner_add', {
          name: this.agent.name,
          phone_number: this.agent.phone_number,
          email: this.agent.email,
          province_code: +this.agent.province_code,
          city_code: +this.agent.city_code,
          advantage: this.agent.advantage,
        }).then(() => {
          utils.msg.success('信息已成功提交，请耐心等待审核结果！');
          this.clearAllField();
          setTimeout(() => {
            scrollTo(0, 0);
          }, 2000);
        }).catch((e) => {
          if (e) console.log(e);
        });
      } else {
        this.emailInvalid = true;
      }
    },
  },
  created() {
    pcdService.getPcd().then(pcds => this.pcds = pcds).catch((e) => {
      if (e) console.log(e);
    });
  },
};
</script>

<style lang="less">
.city-agent {
  textarea {
    height: 120px;
  }
  .error-field {
    input {
      border-color: #ff5a60;
    }
  }
}
</style>

<style lang="less" scoped>
.city-agent {
  width: 100%;
  background-color: #fff;
  line-height: 1;
  .title-left-top {
    position: absolute;
    left: 0;
    top: 0;
  }
  .title-right-bottom {
    position: absolute;
    right: 0;
    bottom: 0;
  }
  .banner {
    height: 478px;
    background-color: #131f2f;
    display: flex;
    justify-content: center;
    .content {
      height: 100%;
      width: 1440px;
      padding: 117px 0 0 222px;
      background-image: url("../assets/imgs/city-agent/banner.jpg");
      background-repeat: no-repeat;
      background-position: center center;
      .banner-title {
        display: flex;
        align-items: center;
      }
      .sub-title {
        color: rgba(109, 232, 241, 0.8);
        font-size: 18px;
        margin-top: 20px;
      }
      .now-apply {
        outline: none;
        cursor: pointer;
        font-size: 20px;
        border-radius: 24px;
        width: 220px;
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid rgba(109, 232, 241, 0.8);
        color: rgba(109, 232, 241, 0.8);
        margin-top: 40px;
        transition: all 0.5s;
        &:hover {
          background-color: rgba(109, 232, 241, 0.8);
          color: #fff;
        }
      }
    }
  }
  .why-ssq {
    height: 520px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .title-box {
      width: 280px;
      height: 63px;
      margin-top: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 28px;
      font-weight: 500;
      color: #5e9be1;
      position: relative;
    }
    .reason {
      margin-top: 30px;
      display: flex;
      font-size: 14px;
      color: #777;
      display: flex;
      flex-direction: column;
      justify-content: center;
      div {
        text-align: center;
        &:last-child {
          margin-top: 10px;
        }
      }
    }
    .detail-reason {
      display: flex;
      justify-content: space-between;
      padding: 0 38px;
      margin-top: 50px;
      width: 877px;
      .reason-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        .img {
          width: 120px;
          height: 120px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .reason-title {
          margin-top: 30px;
          font-size: 18px;
          font-weight: 600;
          color: #333;
        }
        .reason-desc {
          margin-top: 20px;
          li {
            color: #777;
            font-size: 14px;
            text-align: center;
            &:last-child {
              margin-top: 10px;
            }
          }
        }
      }
    }
  }
  .you-got {
    height: 600px;
    .content {
      height: 100%;
      background-image: url("../assets/imgs/city-agent/obtain-bg.jpg");
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      overflow: hidden;
      position: relative;
      .title-box {
        width: 475px;
        height: 63px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 28px;
        font-weight: 500;
        color: #fff;
        margin-top: 36px;
        position: relative;
        z-index: 2;
      }
      .content-box {
        margin-top: 5px;
        width: 955px;
        display: flex;
        justify-content: space-between;
        .index-box {
          display: flex;
          position: relative;
          width: 53px;
          height: 52px;
        }
        .left-content {
          .gots {
            li {
              display: flex;
              margin-top: 70px;
              &:first-child {
                margin-top: 30px;
              }
              &:last-child {
                margin-top: 75px;
              }
              .desc-box {
                margin-left: 10px;
                .desc-title {
                  margin-top: 10px;
                  font-size: 20px;
                  font-weight: 500;
                  color: #5e9be1;
                }
                .desc-items {
                  margin-top: 20px;
                  li {
                    font-size: 14px;
                    color: #fff;
                    margin-top: 10px;
                  }
                }
              }
            }
          }
        }
        .right-content {
          position: relative;
          z-index: 2;
          .gots {
            li {
              display: flex;
              margin-top: 70px;
              &:first-child {
                margin-top: 30px;
              }
              &:last-child {
                margin-top: 75px;
              }
              .desc-box {
                margin-left: 10px;
                .desc-title {
                  margin-top: 10px;
                  font-size: 20px;
                  font-weight: 500;
                  color: #fff;
                }
                .desc-items {
                  margin-top: 20px;
                  li {
                    font-size: 14px;
                    color: #fff;
                    margin-top: 10px;
                  }
                }
              }
            }
          }
        }
      }
      .right-cover,
      .left-cover {
        background-color: rgba(94, 155, 225, 0.8);
        opacity: 0.8;
        position: absolute;
      }
      .right-cover {
        transform: rotate(-18deg);
        transform-origin: left top;
        left: 45%;
        top: 0;
        width: 1500px;
        height: 1000px;
        z-index: 0;
      }
      // .left-cover {
      //   transform: rotate(-18deg);
      //   transform-origin: right top;
      //   right: 60%;
      //   top: -49%;
      //   width: 1500px;
      //   height: 1000px;
      //   z-index: 0;
      // }
    }
  }
  .we-expect {
    height: 600px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .title-box {
      width: 281px;
      height: 63px;
      margin-top: 60px;
      font-size: 28px;
      font-weight: 500;
      color: #5e9be1;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
    }
    .features {
      margin-top: 40px;
      width: 1000px;
      display: flex;
      justify-content: space-between;
      .featrue {
        width: 300px;
        height: 360px;
        background-color: #ffffff;
        box-shadow: 0px 6px 30px 0px rgba(0, 0, 0, 0.05);
        border-radius: 6px;
        display: flex;
        flex-direction: column;
        transition: all 0.5s;
        &:hover {
          transform: translateY(-10px);
          box-shadow: 1px 7px 10px -2px rgba(68, 68, 68, 0.2);
        }
        .img-box {
          height: 200px;
          display: flex;
          justify-content: center;
          align-items: center;
          .img {
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        .content-box {
          background-color: #fff;
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 150px;
          .content-title {
            font-size: 18px;
            font-weight: 600;
            color: #333;
            margin-top: 20px;
          }
          .content-desc {
            list-style-type: none;
            font-size: 14px;
            color: #aaa;
            display: flex;
            flex-direction: column;
            align-items: center;
            li {
              margin-top: 11px;
              &:first-child {
                margin-top: 20px;
              }
            }
          }
        }
      }
    }
  }
  .how-become-agent {
    height: 500px;
    background-color: #fafbfe;
    display: flex;
    flex-direction: column;
    align-items: center;
    .title-box {
      margin-top: 40px;
      width: 411px;
      height: 63px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 28px;
      font-weight: 500;
      color: #5e9be1;
    }
    .steps {
      list-style-type: none;
      width: 1000px;
      height: 250px;
      margin-top: 70px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      .step {
        background-image: linear-gradient(
            45deg,
            rgba(63, 162, 245, 0.43) 0%,
            rgba(63, 230, 245, 0.43) 100%
          ),
          linear-gradient(#5e9be1, #5e9be1);
        background-blend-mode: normal, normal;
        box-shadow: 0px 10px 30px 0px rgba(63, 162, 245, 0.3);
        border: solid 1px rgba(255, 255, 255, 0.2);
        border-radius: 50%;
        width: 160px;
        height: 160px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        transition: all 0.5s;
        &:hover {
          transform: translateY(-8px);
          box-shadow: 0px 10px 30px 0px rgba(63, 162, 245, 0.5);
        }
        .step-img {
          width: 64px;
          height: 64px;
          margin-top: 30px;
        }
        .step-desc {
          margin-top: 20px;
          color: #fff;
          font-size: 17px;
          width: 72px;
          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .bottom {
            margin-top: 5px;
          }
        }
        .step-arrow {
          position: absolute;
        }
      }
      .fill-info {
        .step-arrow {
          bottom: -39px;
          right: -53px;
        }
      }
      .interview {
        align-self: flex-end;
        .step-desc {
          margin-top: 10px;
        }
        .step-arrow {
          right: -76px;
          bottom: 60px;
        }
      }
      .sign-protocol {
        .step-arrow {
          right: -71px;
          bottom: -14px;
        }
      }
      .business-training {
        align-self: flex-end;
        .step-arrow {
          right: -80px;
          bottom: 56px;
        }
      }
    }
  }
  .be-agent {
    height: 760px;
    background-color: #5693d9;
    background-image: url("../assets/imgs/city-agent/application-bg.png");
    background-repeat: no-repeat;
    background-position: center bottom;
    display: flex;
    align-items: center;
    justify-content: center;
    .application-form {
      background-color: #fff;
      border-radius: 10px;
      padding: 40px 15px;
      height: 656px;
      width: 620px;
      .form-head {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .title-box {
          width: 407px;
          height: 65px;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          .title {
            font-size: 24px;
            font-weight: 500;
            color: #5e9be1;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
          }
        }
        .form-attention {
          color: #777;
          font-size: 14px;
          margin-top: 20px;
          margin-bottom: 40px;
        }
      }
      #city-agent-from {
        .form-field {
          min-height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          &.email-field {
            .form-label {
              align-self: flex-start;
              padding-top: 10px;
              .required {
                position: absolute;
                left: 0;
                top: 13px;
                font-size: 14px;
                color: #ff5a60;
              }
            }
          }
          &.desc-field {
            height: auto;
            .form-label {
              align-self: flex-start;
              margin-top: 10px;
            }
          }
          .form-label {
            text-align: left;
            font-size: 14px;
            color: #333;
            font-weight: 600;
            position: relative;
            padding-left: 14px;
            width: 90px;
            .required {
              font-size: 16px;
              color: #ff5a60;
              position: absolute;
              left: 0;
              top: 1px;
            }
          }
          .form-content {
            display: flex;
            &.email-content {
              flex-direction: column;
              align-items: flex-start;
            }
            .province-select,
            .city-select {
              width: 160px;
            }
            .city-select {
              margin-left: 10px;
            }
            .text-input {
              width: 330px;
            }
            .error-text {
              display: block;
              color: #ff5a60;
              margin-top: 10px;
              font-size: 14px;
            }
            .textarea-input {
              width: 330px;
              height: 120px;
              textarea {
                height: 120px;
              }
            }
          }
        }
        .form-field + .form-field {
          margin-top: 20px;
        }
        .btn-box {
          margin-top: 30px;
          display: flex;
          justify-content: center;
          .submit-btn {
            width: 300px;
            height: 48px;
            background-image: linear-gradient(-27deg,
              rgba(63, 162, 245, 0.43) 0%,
              rgba(63, 230, 245, 0.43) 100%),
            linear-gradient(
              #5e9be1,
              #5e9be1);
            background-blend-mode: normal,
              normal;
            box-shadow: 0px 10px 30px 0px
              rgba(63, 162, 245, 0.3);
            border-radius: 24px;
            font-size: 18px;
          }
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/CityAgent.vue